module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_cx-d9db639907f5af31487c707cfb4bbd97.svg";